import { render, staticRenderFns } from "./MemberchipAdd.vue?vue&type=template&id=38b860c2"
import script from "./MemberchipAdd.vue?vue&type=script&lang=js"
export * from "./MemberchipAdd.vue?vue&type=script&lang=js"
import style0 from "./MemberchipAdd.vue?vue&type=style&index=0&id=38b860c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports